import { Row, Col, Checkbox } from "@folio/stripes/components";
import React from "react";
export var ArchivedAccordionContent = function (_a) {
    var archived = _a.archived;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: 12 },
            React.createElement(Checkbox, { label: "Archivov\u00E1no", checked: archived, readOnly: true }))));
};
